import { jwtDecode } from 'jwt-decode';
import { LOCALSTORAGE_KEY_LOGIN } from './Constants';

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch {
    return true; 
  }
}

export function resetAllLoginData() {
  localStorage.removeItem('palavraChave2FA');
  localStorage.removeItem('tokenJWT');
  localStorage.removeItem('tokenJWT2FA');
  localStorage.removeItem('userData');
  localStorage.removeItem(LOCALSTORAGE_KEY_LOGIN);
}
